import {API_URL} from "../config";
import axios from "../utils/axios";

class CameraRepository
{
    save(data) {
        return axios.post(API_URL + "/Camera/Save", data);
    }

    getAll(filter) {
        return axios.get(API_URL + "/Camera/List?", { params: filter });
    }

    getById(id) {
        return axios.get(API_URL + `/Camera/${id}`);
    }

    delete(id) {
        return axios.delete(API_URL + `/Camera/${id}`);
    }

    getSelector(parkingZoneId) {
        return axios.get(API_URL + `/Camera/Selector`, { params: { parkingZoneId: parkingZoneId }});
    }

    getSelectorWithParkingZone() {
        return axios.get(API_URL + `/Camera/SelectorWithParkingZone`, { });
    }

}

export default CameraRepository;
